<template>
  <div class="paySuccess">
    <div class="text">
      <p>
        温馨提示：
      </p>
      <p>
        1.为了确保您能够按时出行，产品确认后请在24小时内付款，同时请按要求尽快提供出游所需的材料并签订出境旅游合同.
      </p>
      <p>
        2.请在报名时交纳团款，我方收到团款后保留机位，非拒签原因客人取消行程，机票定金以及产生的签证费用将不予退还；无论客人是否参加面试，领馆将不予退还签证费。若签证出来后,由于客人的原因在出团前取消,根据情况,收取损失费用.
      </p>
      <p>
        3.所有团队达到成团标准人数即成团，未达到标准我社有权利调整出发日期或取消团期，提前1个月通知.
      </p>
      <p>
        4.我公司保留因签证、机票、税金、汇率涨价等因素，对行程、出发日期及价格进行调整的权利.
      </p>
      <p>
        5.如因航空公司运力调配、航权审核、机场临时关闭、天气原因、航空管制等不可控制或其他不可抗拒力导致航班取消或延期的，我司不承担违约责任，我司将努力协助您办理变更事宜，如产生差价，多退少补.
      </p>
    </div>
    <div class="payData">
      <img src="//lyn.oss-cn-shenzhen.aliyuncs.com/temp/pay_success_icon.png" alt="">
      <div style="margin-left:30px;">
        <h1>
          订单支付成功！
        </h1>
        <h3>
          订单号：{{orderNo}}
        </h3>
        <h3>已付款：￥{{money}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
   data(){
     return{
       orderNo:'',
       money:''
     }
   },
   created(){
     this.data = this.$route.query.orderNo
     this.money = this.$route.query.payAmount
   }
}
</script>

<style lang="less" scoped>
  .paySuccess {
    width:1170px;
    margin: 0 auto;
  }
  .text {
    margin-top: 20px;
    background-color: #fff9ec;
    padding: 30px;
    p {
      font-size: 14px;
      margin-bottom: 10px;
      color: rgb(85, 85, 85);
    }
  }
  .payData {
    display: flex;
    margin-top: 50px;
    justify-content: center;
    border: 1px solid #f3f3f3;
    border-top: none;
    align-items: center;
    padding: 30px;
    h1 {
      color: #ff6600;
      font-weight: normal;
      font-size: 48px;
    }
    h3 {
      font-weight: normal;
      color: #7b7b7b;
      font-size: 26px;
    }
  }
</style>